import React from 'react';

// Stroke glyphs for the furniture panel: same house style as the professions
// menu icons (24x24, currentColor, simple geometry), so they take the colour of
// whatever palette the player picked.
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

const G: Record<string, JSX.Element> = {
  chair: (
    <svg {...base}>
      <path d="M8 3v11h9" />
      <path d="M8 14v7M17 14v7" />
      <path d="M8 8.5h5" />
    </svg>
  ),
  stool: (
    <svg {...base}>
      <path d="M6 8h12v2H6z" />
      <path d="M8 10l-1.5 10M16 10l1.5 10" />
      <path d="M9 15h6" />
    </svg>
  ),
  bench: (
    <svg {...base}>
      <path d="M3 10h18v3H3z" />
      <path d="M5.5 13v7M18.5 13v7" />
      <path d="M5.5 17h13" />
    </svg>
  ),
  bed: (
    <svg {...base}>
      <path d="M3 19V6" />
      <path d="M3 15h18v4" />
      <path d="M21 15v-3a3 3 0 0 0-3-3h-8v6" />
      <path d="M5.5 12h2.5" />
    </svg>
  ),
  table: (
    <svg {...base}>
      <path d="M3 8h18" />
      <path d="M6 8v12M18 8v12" />
      <path d="M9 8v3M15 8v3" />
    </svg>
  ),
  chest: (
    <svg {...base}>
      <path d="M4 10h16v10H4z" />
      <path d="M4 10c0-4 3-6 8-6s8 2 8 6" />
      <path d="M12 13v3" />
    </svg>
  ),
  wardrobe: (
    <svg {...base}>
      <path d="M5 3h14v18H5z" />
      <path d="M12 3v18" />
      <path d="M10 12h.01M14 12h.01" />
      <path d="M7 21v1.5M17 21v1.5" />
    </svg>
  ),
  barrel: (
    <svg {...base}>
      <path d="M7 3h10c2 4 2 14 0 18H7C5 17 5 7 7 3z" />
      <path d="M6 8h12M6 16h12" />
    </svg>
  ),
  crate: (
    <svg {...base}>
      <path d="M4 6h16v14H4z" />
      <path d="M4 6l16 14M20 6L4 20" />
    </svg>
  ),
  shelf: (
    <svg {...base}>
      <path d="M4 3v18M20 3v18" />
      <path d="M4 9h16M4 15h16M4 21h16" />
      <path d="M8 9V6h3v3M14 15v-3h3v3" />
    </svg>
  ),
  logs: (
    <svg {...base}>
      <path d="M3 15h18v5H3z" />
      <path d="M5 10h14v5H5z" />
      <path d="M8 5h8v5H8z" />
    </svg>
  ),
  rack: (
    <svg {...base}>
      <path d="M4 21V4M20 21V4" />
      <path d="M4 4h16M4 9h16" />
      <path d="M8 9v6M12 9v8M16 9v5" />
    </svg>
  ),
  candle: (
    <svg {...base}>
      <path d="M10 21h4v-9h-4z" />
      <path d="M12 3c2 2 2 4 0 5.5C10 7 10 5 12 3z" />
    </svg>
  ),
  lantern: (
    <svg {...base}>
      <path d="M9 3h6" />
      <path d="M8 6h8v13H8z" />
      <path d="M10 19v2h4v-2M12 9v6" />
    </svg>
  ),
  chandelier: (
    <svg {...base}>
      <path d="M12 2v5" />
      <path d="M4 12c1.5 5 14.500 5 16 0" />
      <path d="M7 8v3M12 7v4M17 8v3" />
    </svg>
  ),
  flame: (
    <svg {...base}>
      <path d="M12 3c3 4 5 6 5 9a5 5 0 0 1-10 0c0-2 1-3 2-5 1 2 2 2 3 1 0-2 0-3 0-5z" />
      <path d="M8 21h8" />
    </svg>
  ),
  rug: (
    <svg {...base}>
      <path d="M3 7h18v10H3z" />
      <path d="M6 10h12v4H6z" />
      <path d="M3 9H1.500M3 12H1.500M3 15H1.500M21 9h1.500M21 12h1.500M21 15h1.500" />
    </svg>
  ),
  pelt: (
    <svg {...base}>
      <path d="M6 4c2 1 10 1 12 0l3 5-3 3 2 8-5-3-5 3 2-8-3-3z" />
    </svg>
  ),
  banner: (
    <svg {...base}>
      <path d="M4 3h16" />
      <path d="M6 3h12v14l-6-4-6 4z" />
    </svg>
  ),
  cauldron: (
    <svg {...base}>
      <path d="M5 9h14" />
      <path d="M5 9c0 8 2 11 7 11s7-3 7-11" />
      <path d="M3 9h2M19 9h2M8 20v1.500M16 20v1.500" />
      <path d="M10 6c1-1 1-2 0-3" />
    </svg>
  ),
  box: (
    <svg {...base}>
      <path d="M4 8l8-4 8 4v9l-8 4-8-4z" />
      <path d="M4 8l8 4 8-4M12 12v9" />
    </svg>
  ),
  coin: (
    <svg {...base}>
      <circle cx="12" cy="12" r="8" />
      <path d="M9 12h6" />
    </svg>
  ),
  search: (
    <svg {...base}>
      <circle cx="11" cy="11" r="6" />
      <path d="M16 16l4 4" />
    </svg>
  ),
  all: (
    <svg {...base}>
      <path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z" />
    </svg>
  ),
};

const CATEGORY_GLYPH: Record<string, string> = {
  seat: 'chair',
  bed: 'bed',
  table: 'table',
  storage: 'chest',
  shelf: 'shelf',
  light: 'candle',
  decor: 'banner',
};

const norm = (s: string): string => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

// The glyph that best says what a piece is: by its name first (a "Table de
// chevet" is a table, a "Lustre" hangs), by its category otherwise.
export function glyphIdFor(name: string, category = ''): string {
  const n = norm(name);
  const rules: Array<[RegExp, string]> = [
    [/tabouret/, 'stool'],
    [/\bbanc\b/, 'bench'],
    [/chaise|fauteuil/, 'chair'],
    [/paillasse|couchage|\blit\b/, 'bed'],
    [/lustre/, 'chandelier'],
    [/lanterne/, 'lantern'],
    [/brasero|foyer/, 'flame'],
    [/bougeoir|chandelier|candelabre|applique|torche/, 'candle'],
    [/table/, 'table'],
    [/armoire|commode|buffet/, 'wardrobe'],
    [/coffre/, 'chest'],
    [/tonneau/, 'barrel'],
    [/caisse/, 'crate'],
    [/etagere/, 'shelf'],
    [/buche/, 'logs'],
    [/sechoir|etal/, 'rack'],
    [/tapis/, 'rug'],
    [/peau/, 'pelt'],
    [/banniere/, 'banner'],
    [/chaudron/, 'cauldron'],
  ];
  for (const [rx, id] of rules) if (rx.test(n)) return id;
  return CATEGORY_GLYPH[category] ?? 'box';
}

export const Glyph: React.FC<{ id: string }> = ({ id }) => G[id] ?? G.box;

export const DecorGlyph: React.FC<{ name: string; category?: string }> = ({ name, category }) => <Glyph id={glyphIdFor(name, category)} />;

export const CATEGORY_ICON = (id: string): string => (id === 'all' ? 'all' : CATEGORY_GLYPH[id] ?? 'box');
